import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import Select from 'react-select'

const VatEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);

    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },
            isPopup() {
                return true;
            }
        };
    });

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };

    const onSelectChange = val => {
        setSelectedVal(val);
        setTimeout(function () {
            props.api.stopEditing();
            props.node.setDataValue("vat", val);
        });
    };

    const onMouseOver = e => {
        refContainer.current.setState({ isOpen: true });
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container !== undefined) {
            container.focus();
        }
    };

    return (
        <div style={{ width: props.column.actualWidth + 'px' }}>
            <span onMouseOver={onMouseOver} className="selectCell">
                <Select
                    autosize={true}
                    menuIsOpen={true}
                    defaultValue={selectedVal}
                    onChange={onSelectChange}
                    onChangeValue={onSelectChange}
                    menuPortalTarget={document.body}
                    styles={{
                        menu: (provided) => ({ ...provided, minWidth: 250, border: '4px #333', zIndex: 9999 }),
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                    options={props.colDef.options}
                    ref={refContainer}
                />
            </span>
        </div>
    );
});

export default VatEditor;